import { render, staticRenderFns } from "./DailyRoutineMassUpdate.vue?vue&type=template&id=2bfc5ec2&scoped=true"
import script from "./DailyRoutineMassUpdate.vue?vue&type=script&lang=js"
export * from "./DailyRoutineMassUpdate.vue?vue&type=script&lang=js"
import style0 from "./DailyRoutineMassUpdate.vue?vue&type=style&index=0&id=2bfc5ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc5ec2",
  null
  
)

export default component.exports